
/**
 * @export
 * @enum {string}
 */
export enum RequestStatus {
    CREATED = 'CREATED',
    APPROVED = 'APPROVED',
    DECLINED = 'DECLINED'
}